import React, { createContext, useState, useEffect } from 'react'
import { fetchFreeAgentsForYear, FreeAgent, FeedItem, getFeedByTag } from '../../Api'
import { CURRENT_YEAR } from '../../Config/League/league.config'

type FreeAgencyContextType = {
  players: FreeAgent[]
  news: FeedItem[]
  loading: boolean
}

export const FreeAgencyContext = createContext<FreeAgencyContextType | null>(
  null
)

export const FreeAgencyProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [players, setPlayers] = useState<FreeAgent[]>([])
  const [news, setNews] = useState<FeedItem[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    Promise.all([getFreeAgency(), getFreeAgencyNews()])
  }, [])

  const getFreeAgency = async () => {
    try {
      const freeAgentList = await fetchFreeAgentsForYear(CURRENT_YEAR)
      setPlayers(freeAgentList)
      setLoading(false)
      return
    } catch (err) {
      setLoading(false)
      return err
    }
  }

  const getFreeAgencyNews = async () => {
    const feedParams = {
    tags: ['free-agency'],
    includeVideos: true,
    limit: 12,
  }
    try {
      const feed = await getFeedByTag(feedParams)
      if (!feed) return []
      setNews(feed)
      setLoading(false)
      return
    } catch (err) {
      setLoading(false)
      return err
    }
  }

  return (
    <FreeAgencyContext.Provider
      value={{
        players,
        news,
        loading,
      }}
    >
      {children}
    </FreeAgencyContext.Provider>
  )
}
